<template>
  <div class="page_wrapper">
    <div class="dis_flex dict_wrapper">
      <div class="dis_flex">
        <a-icon type="left-circle" class="btn_back" theme="twoTone" @click="$router.go(-1)" />
        <h2 class="title_from">{{ formTitle }}</h2>
      </div>
      <a-radio-group>
        <!-- editNumInfo = !editNumInfo -->
        <!-- <a-button class="" type="primary" :loading="iconLoading" @click="editFn">
            编辑
          </a-button>
          <a-button class="" v-show="editNumInfo" type="primary" @click="saveHandle"
            >
            提交
          </a-button> -->
        <CuButtons :load="editNumInfo" @saveHandle="saveHandle" @edit="editFn" />
      </a-radio-group>
    </div>

    <div class="data_wrapper">
      <a-form-model ref="dataInfo" :model="dataInfo" :rules="rules">
        <div v-if="editNumInfo" class="row_data">
          <a-form-model-item class="item_businessDis" colon label="所属区域" prop="districtId">
            <a-select show-search placeholder="请选择" v-model="dataInfo.districtId" @change="districtChange">
              <a-select-option v-for="item in disList" :key="item.areaId" :value="item.areaId">
                {{ item.areaName }}
              </a-select-option>
            </a-select>
          </a-form-model-item>

          <a-form-model-item class="item_businessDis" colon label="所属商圈" prop="businessDistrictId">
            <a-select
              show-search
              placeholder="商圈"
              v-model="dataInfo.businessDistrictId"
              :default-active-first-option="false"
              :show-arrow="true"
              :filter-option="false"
              :not-found-content="null"
              @search="businessDisSearch"
              @change="businessDistrictMethod($event, 'editStreet')"
            >
              <a-select-option v-for="item in businessDisList" :key="item.id" :value="item.id">{{
                item.businessDistrictName
              }}</a-select-option>
            </a-select>
          </a-form-model-item>

          <a-form-model-item class="item_businessDis" colon label="街道全称" prop="streetFullName">
            <a-input v-model="dataInfo.streetFullName" :max-length="25" placeholder="街道全称" />
          </a-form-model-item>
        </div>
        <div v-else class="row_data">
          <a-form-model-item class="item_businessDis" colon label="所属区域" prop="districtId">
            {{ dataInfo.districtId | filterList(disList, 'business') }}
          </a-form-model-item>
          <a-form-model-item class="item_businessDis" colon label="所属商圈" prop="businessDistrictId">
            {{ dataInfo.businessDistrictId | filterList(businessDisList, 'businessDis') }}
          </a-form-model-item>

          <a-form-model-item class="item_businessDis" colon label="街道全称" prop="streetFullName">
            {{ dataInfo.streetFullName }}
          </a-form-model-item>
        </div>

        <div>
          <table class="tb_street" cellpadding="0" cellspace="0">
            <thead>
              <tr>
                <td>
                  号
                  <a-button v-if="editNumInfo" type="link" @click="showBatchModel"
                    ><a-icon type="plus-circle"
                  /></a-button>
                </td>
                <td>
                  附号
                  <!-- <a-button
                      v-if="editNumInfo"
                      type="link"
                      @click="addNumHandle"
                    ><a-icon
                      type="plus-circle"
                    /></a-button> -->
                </td>
                <td>经营行业</td>
                <td>品牌</td>
                <!--  <td>地图标记</td> -->
                <td></td>
              </tr>
            </thead>
          </table>

          <table v-show="!editNumInfo" class="tb_street" cellpadding="0" cellspace="0">
            <tbody v-for="(house, index) in showHouseArr" :key="index">
              <tr v-for="(item, subindex) in house.attachedList" :key="subindex">
                <td v-if="subindex == 0" :rowspan="house.attachedList.length">{{ item.houseNumber }}号</td>
                <td>
                  {{ item.attachedNumber }}
                </td>
                <td>
                  {{ item.industryCategoryName }}
                  {{ item.industrySubclassName }}
                </td>
                <td>
                  {{ item.brandName }}
                </td>
                <!--  <td>
                    {{item.mapFlag == 'N' ? '未标记' :'已标记'}}
                    </td> -->
                <td>
                  <a-button v-if="editNumInfo" class="" type="link" @click="removeHandle(item, index)">
                    <a-icon type="minus-circle" />
                  </a-button>
                </td>
              </tr>
            </tbody>
          </table>

          <!-- 现在的编辑列表 -->
          <CuTable
            v-show="editNumInfo"
            @addNumHandle="addNumHandle"
            @removeHandle="removeHandle"
            @pointChange="pointChange"
            @industrySubCategoryChange="industrySubCategoryChange"
            @industryCategoryChange="industryCategoryChange"
            :industryClass="industryClass"
            :industrySubclass="industrySubclass"
            :tableData="houseNumberArr"
          />

          <!-- 之前的编辑列表 -->
          <table v-if="false" class="tb_street" cellpadding="0" cellspace="0">
            <tbody>
              <tr v-for="(item, index) in houseNumberArr" :key="index">
                <!-- :key="item.houseNumber+'_'+item.attachedNumber+'_'+item.businessType+'_'+item.brandName" -->
                <td>
                  <a-form-model-item
                    :class="index == houseNumberArr.length - 1 ? 'input_width' : ''"
                    class="item_street"
                    colon
                    label=""
                    prop="houseNumber"
                  >
                    <!-- <a-input
                        size="default"
                        :value="item.houseNumber"
                        placeholder="号(例：1)"
                        :max-length="10"
                        suffix="号"
                        @change="pointChange($event, item.attachedNumber, 'houseNumber')"
                      /> -->
                    <CuInput
                      @inputChange="pointChange"
                      type="number"
                      :item="item"
                      itemKey="houseNumber"
                      :maxLength="10"
                      :defaultValue="item.houseNumber || '0'"
                      placeholder="号(例：1)"
                    />
                    <a-button
                      v-if="index == houseNumberArr.length - 1"
                      type="link"
                      @click="addNumHandle('houseNumber', item)"
                      ><a-icon type="plus-circle"
                    /></a-button>
                  </a-form-model-item>
                </td>
                <td>
                  <!-- <a-input v-show="3 === 2" v-model="item.houseNumber" /> -->
                  <a-form-model-item
                    :class="index == houseNumberArr.length - 1 ? 'input_width' : ''"
                    class="item_street"
                    colon
                    label=""
                    prop="attachedNumber"
                  >
                    <!-- <a-input
                        size="default"
                        v-model="item.attachedNumber"
                        placeholder="附号(例：附1号)"
                        :max-length="10"
                        @change="pointChange($event,item.attachedNumber,'attachedNumber')"
                      /> -->
                    <CuInput
                      @inputChange="pointChange"
                      type="number"
                      :item="item"
                      itemKey="attachedNumber"
                      :maxLength="10"
                      :defaultValue="item.attachedNumber || '0'"
                      placeholder="附号(例：附1号)"
                    />

                    <a-button
                      v-if="index == houseNumberArr.length - 1"
                      type="link"
                      @click="addNumHandle('attachedNumber', item)"
                      ><a-icon type="plus-circle"
                    /></a-button>
                  </a-form-model-item>
                </td>
                <td>
                  <a-form-model-item class="item_street" colon label="" prop="businessType">
                    <!-- mode="multiple" -->
                    <!-- <a-select
                        placeholder="行业大类"
                        style="width: 90px"
                        v-model="item.industryCategoryId"
                        @change="industryCategoryChange(item, index)"
                      >
                        <a-select-option v-for="type in industryClass" :key="type.id" :value="type.id">{{
                          type.industryCategoryName
                        }}</a-select-option>
                      </a-select> -->
                    <CuSelect
                      @change="industryCategoryChange"
                      :index="index"
                      :item="item"
                      itemKey="industryCategoryId"
                      :options="industryClass"
                      placeholder="行业大类"
                    />
                    <!-- <a-select
                        placeholder="行业小类"
                        style="width: 90px"
                        v-model="item.industrySubclassId"
                        @change="industrySubCategoryChange(item, index)"
                      >
                        <a-select-option v-for="sub in item.showIndustrySubclass" :key="sub.id" :value="sub.id">{{
                          sub.industryCategoryName
                        }}</a-select-option>
                      </a-select> -->
                    <CuSelect
                      @change="industrySubCategoryChange"
                      :index="index"
                      :item="item"
                      itemKey="industrySubclassId"
                      :options="item.showIndustrySubclass"
                      placeholder="行业小类"
                    />
                  </a-form-model-item>
                </td>
                <td>
                  <a-form-model-item class="item_street" colon label="">
                    <!-- <a-input :key="index + '_brandName'"  :max-length="20" v-model="item.brandName"  @change="($event)=>item.brandName= $event.target.value"  placeholder="请输入品牌信息" /> -->
                    <CuInput :item="item" itemKey="brandName" :maxLength="20" placeholder="请输入品牌信息" />
                  </a-form-model-item>
                </td>
                <!-- <td>
                      未标记
                      <a-form-model-item class="item_street" colon  label="" prop="mapFlag">
                        <a-input v-show="3===2" v-model="item.mapFlag" value="N" />
                      </a-form-model-item>
                    </td> -->
                <td>
                  <a-button class="" type="link" v-if="houseNumberArr.length != 1" @click="removeHandle(item, index)">
                    <a-icon type="minus-circle" />
                  </a-button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- <a-form-model-item class="btn_opts" >
              <a-button  class="btn_opt" type="primary" :loading="submitLoading" @click="submitForm">
                保存
              </a-button>
              <a-button  class="btn_opt" type="dashed" @click="goList">
                取消
              </a-button>
          </a-form-model-item> -->
      </a-form-model>
      <a-modal v-model="visibleBatch" title="门牌号管理" @ok="addNumBatchHandle">
        <div class="">
          <a-form-model ref="numForm" :model="numForm" :rules="numFormRules">
            <a-form-model-item class="item_businessDis" colon label="起始门牌号" prop="minNum">
              <a-input v-model="numForm.minNum" :max-length="10" placeholder="起始门牌号" />
            </a-form-model-item>
            <a-form-model-item class="item_businessDis" colon label="终止门牌号" prop="maxNum">
              <a-input v-model="numForm.maxNum" :max-length="10" placeholder="终止门牌号" />
            </a-form-model-item>
            <a-form-model-item class="item_businessDis" colon label="奇偶类型" prop="maxNum">
              <a-select placeholder="请选择" style="width: 90px" v-model="numForm.type" @change="typeChange">
                <a-select-option v-for="item in addTypeOpts" :key="item.value" :value="item.value">{{
                  item.label
                }}</a-select-option>
              </a-select>
            </a-form-model-item>
          </a-form-model>
        </div>
      </a-modal>
    </div>
  </div>
</template>

<script>
// import { districtList } from '@/api/setting/district'
import { sysList } from '@/api/setting/sys'
import { areaList } from '@/api/setting/area'
import { businessDistrictList } from '@/api/setting/businessdistrict'
import {
  getStreet,
  addStreet,
  updateStreet,
  delAttached,
  //  , streetList, delStreet
} from '@/api/setting/street'
import { industryCategoryList } from '@/api/system/industry'
import CuInput from './modules/cu-input.vue'
import CuSelect from './modules/cu-select.vue'
import CuButtons from './modules/cu-buttons.vue'
import CuTable from './modules/cu-table.vue'
export default {
  name: 'StreetSave',
  props: {},
  components: { CuInput, CuSelect, CuButtons, CuTable },
  data() {
    return {
      pageLoading: false,
      visibleBatch: false, // 批量生成的页面标识
      iconLoading: false,
      numForm: {
        minNum: undefined,
        maxNum: undefined,
        type: 'odd',
      },
      numFormRules: {
        minNum: [{ required: true, pattern: /^([0-9]){1,6}$/, message: '格式错误', trigger: 'blur' }],
        maxNum: [{ required: true, pattern: /^([0-9]){1,6}$/, message: '格式错误', trigger: 'blur' }],
        type: [{ required: true, message: '必选', trigger: 'blur' }],
      },
      submitLoading: false,
      formTitle: '新增街道信息',
      opt: 'add', // 操作 add 新增 ，edit 修改
      showNumModal: false, // 是否显示添加门牌号与附号
      editNumInfo: false, // 编辑信息
      houseNumberArr: [
        {
          showIndustrySubclass: [], // 显示的经营小类
          // 门牌符号
          attachedNumber: '0', //	门牌附号		true
          brandName: undefined, //	品牌		false
          businessType: undefined, //	经营类型		false
          houseNumber: '0', //	门牌号		true
          id: undefined, //	id，新增时不传，修改时必传		true
          mapFlag: undefined, //	地图标记		false
          streetId: undefined, //	街道ID,新增时不传，修改时必传		true
        },
      ], // 门牌号

      showHouseArr: [],
      queryParamDistrict: {
        districtFullName: undefined, // 区域全称
        districtShortName: undefined, // 区域简称
      },
      queryBusinessDisParam: {
        businessDistrictName: undefined, // 商圈名称
        districtId: undefined, // 区域ID
      },
      disList: [],
      businessDisList: [],
      loading: false,

      districtOpts: [], // 区域
      businessTypeOpts: [], // 经营类型
      industrySubOpts: [], // 经营子类

      queryArea: {
        areaName: undefined, //	名称
        level: 3, // 等级（1：省 2：市 3：区）
        parentId: undefined, //	父类ID
      },
      // 表单参数
      dataInfo: {
        attachedInfoBoList: [
          {
            // 附号信息List
            attachedNumber: undefined, //	门牌附号		true
            brandName: undefined, //	品牌		false
            businessType: undefined, //	经营类型		false
            houseNumber: undefined, //	门牌号		true
            id: undefined, //	id，新增时不传，修改时必传		true
            mapFlag: undefined, //	地图标记		false
            streetId: undefined, //	街道ID,新增时不传，修改时必传		true
            industryCategoryId: undefined, //	行业大类ID（可经营）		false
            industryCategoryName: undefined, //	行业大类名称（可经营）		false
            industrySubclassId: undefined, //	行业小类ID（可经营）		false
            industrySubclassName: undefined, //	行业小类名称（可经营）		false
          },
        ],
        districtId: undefined, //	区域ID		true（+）
        businessDistrictId: undefined, //	商圈ID		true
        id: undefined, //	id，新增时不传，修改时必传		true
        streetFullName: undefined, //	街道全称
      },
      keyId: undefined,
      rules: {
        // districtId: [{ required: true, message: '必填', trigger: 'blur' }],
        businessDistrictId: [{ required: true, message: '必填', trigger: 'blur' }],
        streetFullName: [{ required: true, message: '必填', trigger: 'blur' }],
      },
      industryClass: [], // 所有经营大类/显示的大类
      industrySubclass: [], // 满足条件的经营小类
      showIndustrySubclass: [], // 显示的经营小类

      canIndustryCategoryList: [], // 可经营大类
      canSubIndustryCategoryList: [], // 可经营小类
      addTypeOpts: [
        { value: 'odd', label: '奇数' },
        { value: 'even', label: '偶数' },
        // { value: 'continuity', label: '连续' }
      ],
    }
  },
  filters: {
    filterDict(val, opts) {
      if (!val) return
      for (const d of opts) {
        if (d.dictValue == val) {
          return d.dictLabel
        }
      }
    },
    filterList(val, list, type) {
      if (!val) return
      for (const item of list) {
        if (type === 'business' && item.areaId.toString() === val.toString()) {
          return item.areaName
        } else if (type === 'businessDis' && item.id.toString() === val.toString()) {
          return item.businessDistrictName
        }
      }
    },
  },
  created() {
    this.reset()
    this.initData()
  },
  computed: {},
  watch: {},
  methods: {
    editFn(val) {
      this.editNumInfo = val
      this.iconLoading = true
      // console.log('1111111111',this.editNumInfo);
      this.$nextTick(() => {
        // console.log('22222222',this.editNumInfo);
        // this.iconLoading = false
      })
    },
    inputChange(e, val) {
      val = e.data
      // item = val.data
      console.log(e, val, '999')
    },
    initData() {
      this.pageLoading = true
      this.getDisList(() => {
        // 街道id
        let streetId = this.$route.query.dataId
        if (streetId !== '' && streetId != null && typeof streetId !== 'undefined') {
          this.opt = 'edit'
          this.formTitle = '修改街道信息'
          // 修改
          streetId = parseInt(this.$route.query.dataId)
          // this.dataInfo.keyId=businessDisId;
          // 街道详情
          getStreet(streetId).then((response) => {
            this.dataInfo = response.data
            const volist = this.dataInfo.attachedInfoVoList
            this.houseNumberArr = volist
            this.dataInfo.attachedInfoBoList = volist

            const houseNumberArr = []
            const houseNumberArr_ = []
            for (const vo of volist) {
              houseNumberArr_.push(vo.houseNumber)
            }
            var set = new Set(houseNumberArr_)
            // 将set转换为数组
            const [...newHouseNumberArr_] = set
            // console.log(newHouseNumberArr_)

            const newHouseNumberArr = []
            for (const obj of newHouseNumberArr_) {
              newHouseNumberArr.push({
                houseNumber: obj,
                attachedList: [],
              })
            }

            const _arr = []
            for (const h of newHouseNumberArr) {
              let attArr = []
              for (const vo of volist) {
                houseNumberArr.push(vo.houseNumber)
                if (h.houseNumber === vo.houseNumber) {
                  attArr.push(vo)
                }
              }
              h.attachedList = attArr
              attArr = []
              _arr.push(h)
            }

            this.showHouseArr = _arr
            if (this.showHouseArr.length === 0) {
              this.houseNumberArr.push({
                // 附号信息List
                attachedNumber: '0', //	门牌附号		true
                brandName: undefined, //	品牌		false
                businessType: undefined, //	经营类型		false
                houseNumber: '0', //	门牌号		true
                id: undefined, //	id，新增时不传，修改时必传		true
                mapFlag: undefined, //	地图标记		false
                streetId: undefined, //	街道ID,新增时不传，修改时必传		true
                industryCategoryId: undefined, //	行业大类ID（可经营）		false
                industryCategoryName: undefined, //	行业大类名称（可经营）		false
                industrySubclassId: undefined, //	行业小类ID（可经营）		false
                industrySubclassName: undefined, //	行业小类名称（可经营）		false
              })
            }
            // this.districtChange(this.dataInfo.districtId)
            this.initDistrictList(this.dataInfo.districtId)

            // 行业分类
            this.initIndustryCategory(volist)
            this.$nextTick(() => {
              this.pageLoading = false
            })
          })
        } else {
          this.opt = 'add'
          this.editNumInfo = true
          this.formTitle = '新增街道信息'
          this.businessDisList = []
          // 行业分类
          this.initIndustryCategory(null)
          this.$nextTick(() => {
            this.pageLoading = false
          })
        }
      })
    },
    // 类型变化
    typeChange(val) {
      this.numForm.type = val
    },
    showBatchModel() {
      this.numForm = {
        minNum: undefined,
        maxNum: undefined,
        type: 'odd', // even 偶数  odd奇数 continuity连续
      }
      this.visibleBatch = true
    },
    // 批量添加门牌号
    addNumBatchHandle() {
      this.$refs.numForm.validate((valid) => {
        if (valid) {
          this.submitLoading = true
          let min = parseInt(this.numForm.minNum)
          let max = parseInt(this.numForm.maxNum)
          const type = this.numForm.type
          min = min > max ? max : min
          max = min > max ? min : max
          let houseNum = {
            // 附号信息List
            attachedNumber: undefined, //	门牌附号		true
            brandName: undefined, //	品牌		false
            businessType: undefined, //	经营类型		false
            houseNumber: undefined, //	门牌号		true
            id: undefined, //	id，新增时不传，修改时必传		true
            mapFlag: undefined, //	地图标记		false
            streetId: undefined, //	街道ID,新增时不传，修改时必传		true
            industryCategoryId: undefined, //	行业大类ID（可经营）		false
            industryCategoryName: undefined, //	行业大类名称（可经营）		false
            industrySubclassId: undefined, //	行业小类ID（可经营）		false
            industrySubclassName: undefined, //	行业小类名称（可经营）		false
          }
          console.log(this.dataInfo.attachedInfoBoList)
          if (
            (this.opt === 'add' && this.dataInfo.attachedInfoBoList.length === 1) ||
            (this.dataInfo.attachedInfoBoList && this.dataInfo.attachedInfoBoList.length <= 0)
          ) {
            this.houseNumberArr = []
          }

          // let houseNumberArr_ = []
          for (let i = min; i <= max; i++) {
            if (type === 'even' && i % 2 === 0) {
              // 偶数
              houseNum = JSON.parse(JSON.stringify(houseNum))
              houseNum.houseNumber = i
              houseNum.attachedNumber = ''
              this.houseNumberArr.push(houseNum)
            } else if (type === 'odd' && i % 2 === 1) {
              houseNum = JSON.parse(JSON.stringify(houseNum))
              houseNum.houseNumber = i
              houseNum.attachedNumber = ''
              this.houseNumberArr.push(houseNum)
            } else if (type === 'continuity') {
              houseNum = JSON.parse(JSON.stringify(houseNum))
              houseNum.houseNumber = i
              houseNum.attachedNumber = ''
              this.houseNumberArr.push(houseNum)
            }
          }

          this.dataInfo.attachedInfoBoList = this.houseNumberArr
          this.$forceUpdate()

          this.submitLoading = false
          this.visibleBatch = false
        } else {
          return false
        }
      })
    },

    // 商圈的搜索
    businessDisSearch(value) {
      this.queryBusinessDisParam.districtId = undefined
      this.queryBusinessDisParam.businessDistrictName = value
      this.getBusinessDistrict(this.queryBusinessDisParam)
    },
    // 根据商圈改变事件
    businessDistrictMethod(val, pageName) {
      console.log(this.businessDisList)
      const businessDis = this.businessDisList.find((item) => {
        return item.id === val
      })
      // 区域
      this.dataInfo.districtId = businessDis.districId
      this.dataInfo.businessDistrictId = businessDis.id
      this.getDistrictBusinessInfo(this.dataInfo.districtId)
    },
    // 根据区域id，获取区域、商圈信息（通过街道反查信息）
    getDistrictBusinessInfo(districtId) {
      const regionChild = this.disList.find((item) => {
        return item.areaId === districtId
      })
      this.dataInfo.districtName = regionChild.areaName
      this.getBusinessDistrict({ businessDistrictName: '', districtId: regionChild.areaId })
    },

    // 初始化经营行业（大类）
    initIndustryCategory(voList) {
      this.getIndustryCategoryList('', 1, null) // 所有大类
      this.getIndustryCategoryList('', 2, () => {
        if (this.opt === 'edit' && voList && voList.length > 0) {
          for (let i = 0; i < voList.length; i++) {
            // 获取满足条件的子类数据
            this.getShowSubClass(voList[i].industryCategoryId, i)
          }
        }
      }) // 所有小类
    },
    // 获取经营行业(type 1大类 2小类)
    getIndustryCategoryList(parentId, type, func) {
      this.loading = true
      const parmars = {
        parentId,
        industryCategoryType: type,
      }
      industryCategoryList(parmars).then((res) => {
        const { code, data } = res
        this.loading = false
        if (code === 200) {
          if (type === 1) {
            this.industryClass = data
          } else {
            this.industrySubclass = data
          }
        }
        if (func) {
          func()
        }
      })
    },
    getShowSubClass(classid, idx) {
      // 所有小类
      const allSubClassList = this.industrySubclass
      // 选择的大类(多选为数组，单选为int)
      const idArr = classid
      // 根据选择的小类过滤出显示的小类数据
      //  多选
      //  if (idArr) {
      //   this.showIndustrySubclass = allSubClassList.filter((item) => {
      //     if (idArr.includes(item.parentId) || idArr === item.parentId) {
      //       return item
      //     }
      //   })
      //  }
      // 单选
      this.houseNumberArr[idx].showIndustrySubclass = allSubClassList.filter((item) => {
        if (idArr === item.parentId) {
          return item
        }
      })
    },
    // 大类改变事件
    industryCategoryChange(item, idx, dataSource) {
      // 获取选择的大类id及值
      const list = this.industryClass
      const typeIdArr = item.industryCategoryId // 选择的大类id
      // // 多选
      // const res = []
      // for (const obj of list) {
      //   if (typeIdArr.includes(obj.id)) {
      //     res.push(obj.industryCategoryName)
      //   }
      // }
      // this.houseNumberArr[idx].industryCategoryId = typeIdArr // 行业分类（行业大类）ID
      // this.houseNumberArr[idx].industryCategoryName = res// 行业分类（行业大类）名称
      this.houseNumberArr = dataSource.map((el) => ({ ...el }))
      // 单选
      this.industryClass.forEach((el) => {
        if (item.industryCategoryId == el.id) {
          this.houseNumberArr[idx].industryCategoryName = el.industryCategoryName
        } else {
          this.houseNumberArr[idx].industryCategoryName = ''
          this.houseNumberArr[idx].industryCategoryId = null
        }
      })
      if (!item.industryCategoryId) {
        this.houseNumberArr[idx].industryCategoryId = null
      }
      console.log(this.houseNumberArr, 'this.houseNumberArr')

      // 获取满足条件的子类数据
      this.getShowSubClass(item.industryCategoryId, idx)
    },
    // 小类改变事件
    industrySubCategoryChange(sub, idx) {
      const allSubClassList = this.industrySubclass
      const subTypeIdArr = sub.industrySubclassId
      // const res = []
      // for (const obj of allSubClassList) {
      //   if (subTypeIdArr.includes(obj.id)) {
      //     res.push(obj.industryCategoryName)
      //   }
      // }
      // this.houseNumberArr[idx].industrySubclassId = subTypeIdArr // 经营行业（行业小类）ID
      // this.houseNumberArr[idx].industrySubclassName = res// 经营行业（行业小类）名称

      // 单选
      // for (const obj of allSubClassList) {
      //   if (subTypeIdArr === obj.id) {
      //     this.houseNumberArr[idx].industrySubclassName = obj.industryCategoryName
      //     break
      //   } else {
      //     continue
      //   }
      // }
      this.industrySubclass.forEach((el) => {
        if (sub.industrySubclassId == el.id) {
          this.houseNumberArr[idx].industrySubclassName = el.industryCategoryName
        } else {
          this.houseNumberArr[idx].industrySubclassName = ''
          this.houseNumberArr[idx].industrySubclassId = null
        }
      })
      if (!sub.industrySubclassId) {
        this.houseNumberArr[idx].industrySubclassId = null
      }
    },
    // 获取商圈列表
    getBusinessDistrict() {
      this.loading = true
      // console.log('getBusinessDistrict', this.queryBusinessDisParam)
      businessDistrictList(this.queryBusinessDisParam).then((response) => {
        if (response.code === 200) {
          const resData = response.data
          this.businessDisList = resData
        }
        this.loading = false
      })
    },
    // 获取区域列表
    getDisList(func) {
      //  this.loading = true
      //  districtList(this.queryParamDistrict).then((response) => {
      //     if (response.code === 200) {
      //       const resData = response.data
      //       this.disList = resData
      //     }
      //     this.loading = false
      //   })
      this.getArea(func)
    },
    /** **根据系统信息查询区域信息***/
    getArea(func) {
      this.loading = true
      const param = { pageNum: 1, pageSize: 1 }
      sysList(param).then((response) => {
        if (response.code === 200) {
          const resData_ = response.data
          this.total = resData_.total
          if (this.total > 0) {
            this.list = resData_.records
            this.dataObj = resData_.records[0]
            this.sys = this.dataObj
            this.queryArea.parentId = this.sys.companyCityId
            areaList(this.queryArea).then((res) => {
              if (res.code === 200) {
                const resData = res.data
                const areaList = []
                if (resData != null && resData.length > 0) {
                  for (let i = 0; i < resData.length; i++) {
                    areaList.push({ areaId: resData[i].areaId, areaName: resData[i].areaName, children: [] })
                  }
                  this.disList = areaList
                }
              }
              if (func) {
                func()
              }
              this.loading = false
            })
          } else {
            this.queryArea.parentId = ''
            this.$message.error('公司设置所在市信息获取失败')
          }
        }
        this.loading = false
      })
    },
    initDistrictList(val) {
      // 获取区域下商圈
      this.queryBusinessDisParam.districtId = val // 区域id
      this.getBusinessDistrict()
    },
    districtChange(val) {
      this.dataInfo.businessDistrictId = undefined
      // 获取区域下商圈
      this.queryBusinessDisParam.businessDistrictName = undefined // 商圈名称
      this.queryBusinessDisParam.districtId = val // 区域id
      this.getBusinessDistrict()
    },

    reset() {},

    /** 提交按钮 */
    saveHandle: function () {
      if (!this.validateRepeatHandle()) {
        return
      }
      this.$refs.dataInfo.validate((valid) => {
        if (valid) {
          this.submitLoading = true
          if (this.dataInfo.id !== undefined) {
            updateStreet(this.dataInfo)
              .then((response) => {
                this.$message.success('修改成功', 3)
                this.goList()
              })
              .finally(() => {
                this.submitLoading = false
              })
          } else {
            addStreet(this.dataInfo)
              .then((response) => {
                this.$message.success('新增成功', 3)
                this.goList()
              })
              .finally(() => {
                this.submitLoading = false
              })
          }
        } else {
          return false
        }
      })
    },
    validateRepeatHandle() {
      const nList = this.houseNumberArr
      this.dataInfo.attachedInfoBoList = nList
      const arr = []
      const reg = /^[0-9]{1,6}$/
      // console.log(nList)
      for (const n1 of nList) {
        // console.log(n1.houseNumber, n1.attachedNumber)
        arr.push(n1.houseNumber + '_' + n1.attachedNumber)
        //  arr.push(n1.houseNumber+"_"+n1.attachedNumber+"_"+n1.businessType+"_"+n1.brandName);
        if (!n1.houseNumber || !n1.attachedNumber) {
          this.$message.error('号和附号必填', 3)
          return false
        } else {
          if (reg.test(n1.houseNumber)) {
            if (!isNaN(n1.houseNumber)) {
            } else {
              this.$message.error('格式错误,号必须是数字', 3)
              return false
            }
          } else {
            this.$message.error('格式错误,号必须是数字', 3)
            return false
          }
        }
      }
      var set = new Set(arr)
      // 将set转换为数组
      const [...newArr] = set
      if (newArr.length < arr.length) {
        this.$message.error('街道信息存在重复，请检查', 3)
        return false
      } else {
        return true
      }
    },
    pointChange(e, value, name) {
      const val = e.target.value
      const reg = /^[0-9]{1,6}$/
      if (name === 'houseNumber') {
        if (reg.test(val)) {
          if (!isNaN(val)) {
            //  this.$message.success()
          } else {
            this.$message.error('格式错误,号必须是数字')
          }
        } else {
          this.$message.error('格式错误,号必须是数字')
        }
      }
    },

    goList() {
      this.$router.go(-1)
    },

    addNumHandle(val, item) {
      // this.showNumModal=true;
      const houseNum = {
        // 附号信息List
        attachedNumber: '0', //	门牌附号		true
        brandName: undefined, //	品牌		false
        businessType: undefined, //	经营类型		false
        houseNumber: '0', //	门牌号		true
        id: undefined, //	id，新增时不传，修改时必传		true
        mapFlag: undefined, //	地图标记		false
        streetId: undefined, //	街道ID,新增时不传，修改时必传		true
        industryCategoryId: undefined, //	行业大类ID（可经营）		false
        industryCategoryName: undefined, //	行业大类名称（可经营）		false
        industrySubclassId: undefined, //	行业小类ID（可经营）		false
        industrySubclassName: undefined, //	行业小类名称（可经营）		false
      }
      console.log(val, item, '999')
      let houseNumberArr_ = []
      if (val == 'houseNumber') {
        if (!item.houseNumber) {
          this.$message.error('请完善信息')
          return
        }
        houseNumberArr_ = this.houseNumberArr

        houseNum.houseNumber = this.judgeNum(
          houseNumberArr_ && houseNumberArr_.length > 0
            ? Number(houseNumberArr_[houseNumberArr_.length - 1].houseNumber) + 2 + ''
            : '0'
        )
        houseNum.attachedNumber = ''
      } else {
        if (!item.houseNumber || !item.attachedNumber) {
          this.$message.error('请完善信息')
          return
        }
        houseNumberArr_ = this.houseNumberArr
        houseNum.attachedNumber = this.judgeNum(
          houseNumberArr_ && houseNumberArr_.length > 0
            ? Number(houseNumberArr_[houseNumberArr_.length - 1].attachedNumber) + 1 + ''
            : '0'
        )
        houseNum.houseNumber = this.judgeNum(
          houseNumberArr_ && houseNumberArr_.length > 0
            ? Number(houseNumberArr_[houseNumberArr_.length - 1].houseNumber) + ''
            : '0'
        )
      }
      this.houseNumberArr.push(houseNum)
      this.dataInfo.attachedInfoBoList = this.houseNumberArr
      this.$forceUpdate()
    },
    judgeNum(val) {
      return isNaN(val) ? '' : val
    },
    removeHandle(obj, idx) {
      if (obj.id) {
        // 修改后删除
        this.delHandle(obj)
        this.houseNumberArr.splice(idx, 1)
        this.dataInfo.attachedInfoBoList = this.houseNumberArr
      } else {
        this.houseNumberArr.splice(idx, 1)
        this.dataInfo.attachedInfoBoList = this.houseNumberArr
      }
    },
    delHandle(obj) {
      if (this.submitLoading) {
        this.$message.success('操作过于频繁')
        return
      }
      // console.log(this.submitLoading)
      // return
      this.submitLoading = true
      delAttached(obj.id)
        .then((response) => {
          this.$message.success('删除成功', 3)
          // this.initData()
        })
        .finally(() => {
          this.submitLoading = false
        })
    },
  },
}
</script>
<style lang="less" scoped>
.ml20 {
  margin-left: 20px;
}
.dis_flex {
  display: flex;
  align-items: center;
}
.dict_wrapper {
  display: flex;
  justify-content: space-between;
  padding: 20px;
  background: #fff;
}
.title_from {
  font-weight: bold;
  font-size: 20px;
  margin-bottom: 0px;
}

.data_wrapper {
  margin-top: 10px;
  padding: 20px;
  background: #fff;
}
.row_data {
  display: flex;
  flex-wrap: wrap;
}

.item_businessDis {
  width: 280px;
  margin-right: 20px;
}
.btn_opt {
  margin-right: 50px;
}
.tb_street {
  width: 100%;
}
.tb_street tr td {
  width: 15%;
  border: 1px solid #f2f2f2;
  padding: 5px 5px;
  text-align: center;
  height: 46px;
}
.tb_street tr td:last-child {
  border: none;
  text-align: left;
}
.item_street {
  margin-bottom: 0px;
}
.input_width {
  /deep/ .ant-form-item-children {
    display: flex;
  }
}
.layer {
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: 999999;
  background-color: rgba(0, 0, 0, 0.4);
}
.tb-tr {
  & > div {
    border: 0.5px solid rgba(0, 0, 0, 0.1);
    padding: 10px;
    border-right: none;
  }
  & > div:last-child {
    border: none;
    border-left: 0.5px solid rgba(0, 0, 0, 0.1);
  }
}
</style>
